// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"aca4e764","156":"a05d1dba","809":"a05d1dba","853":"856211d1","865":"aca4e764","961":"856211d1"}[chunkId] + ".chunk.css";
};